module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_house_tvb-48eff04149950524224a4c38e0403582.jpg";